import { MinzeElement } from 'minze'
import type { Attrs } from 'minze'

export class LvcCounter extends MinzeElement {
  attrs: Attrs = [['data-size-preset', 'medium']]
  html = () => `
    <slot></slot>
  `
  css = () => `
    :host {
      margin-top: -4px;
      display: inline-flex;
      height: 34px;
      min-width: 34px;
      padding: 7px;
      justify-content: center;
      align-items: center;
      border-radius: 40px;
      background: #1E007D;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 120%;
      color: #FF4600;
      position: relative;
      top: 2px;
    }
  `
}
